export const accInit = () => {

    const accBtn = document.querySelectorAll('.acc__txt')

    accBtn.forEach((accBtnList) => {
        const ans = accBtnList.previousElementSibling !== null ? accBtnList.previousElementSibling : accBtnList.nextElementSibling;

        let height = (ans.clientHeight + 1) / window.innerWidth * 100;
        ans.style.height = "0vw"

        accBtnList.addEventListener('click', () => {
            openAcc()
        });

        function openAcc() {
            const accBtnParent = accBtnList.parentNode
            accBtnParent.classList.toggle("is-on")

            if (accBtnParent.classList.contains("is-on")) {
                ans.style.height = `${height}vw`
            } else {
                ans.style.height = "0vw"
            }
        }
    })
}
